module.exports = __webpack_public_path__ + "img/2020-05-21.fda89adb.jpg";